
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import QuoteForm from './components/QuoteForm';
import OwnerIntro from './components/OwnerIntro';
import LedWallSystem from './components/LedWallSystem';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <OwnerIntro />
        <LedWallSystem />
        <Services />
        <Portfolio />
        <Testimonials />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
